module.exports = {"id":"227787","name":"Kim Jong Woo","rating":"72","photo":"./data/images/photos/2/227787.png","club":{"name":"Suwon Bluewings","logo":"./data/images/clubs/SuwonBluewings.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KimJongWoo0.json
// module id = 2379
// module chunks = 0